var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.makeOrder}},[_vm._v("send Purchase")])])
}
var staticRenderFns = []

export { render, staticRenderFns }